import { render, staticRenderFns } from "./AreaDialog.vue?vue&type=template&id=02398cba&scoped=true"
import script from "./AreaDialog.vue?vue&type=script&lang=js"
export * from "./AreaDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02398cba",
  null
  
)

export default component.exports